import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('TIMELINE_COMMENT').plugin(axiosPlugin);

let fetchTimelineCommentAction = redux.fetchActionGetOne();

let createTimelineCommentAction = redux.fetchActionCreate();

let updateTimelineCommentAction = redux.fetchActionUpdate();

let deleteTimelineCommentAction = redux.fetchActionDelete();

export const TYPES = redux.types;

export const fetchTimelineComment = (type, parentId, commentId, query = {}) => fetchTimelineCommentAction(`/${type}/${parentId}/comments/${commentId}?${queryString.stringify(query)}`);
export const createTimelineComment = (type, parentId, data) => createTimelineCommentAction(`/${type}/${parentId}/comments`, data);
export const updateTimelineComment = (type, parentId, commentId, data = {}) => updateTimelineCommentAction(`/${type}/${parentId}/comments/${commentId}`, data);
export const deleteTimelineComment = (type, parentId, commentId) => deleteTimelineCommentAction(`/${type}/${parentId}/comments/${commentId}`);
export const resetTimelineComment = () => redux.actions.reset();
export const timelineComment = redux.reducer();